export const publicPath = (relative: string): string =>
  `${process.env.PUBLIC_URL}${relative}`;
